<template>

</template>

<script>
  export default {
    components: {
    },
    data() {
      return {
      }
    },
    created() {
    },
    methods: {
    },
    mounted: function () {
    },
    beforeDestroy() {

    }
  }
</script>

